import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web

import usersReducer from './features/users';
import membersReducer from './features/members';
import recordsReducer from './features/records';

// Persist config for the users reducer
const usersPersistConfig = {
  key: 'users',
  storage,
};

// Persisted users reducer
const persistedUsersReducer = persistReducer(usersPersistConfig, usersReducer);

// Combine the reducers
const reducers = combineReducers({
  users: persistedUsersReducer,
  members: membersReducer,
  records: recordsReducer,
});


const rootReducer = (state, action) => {
  if (action.type === 'users/logoutUser') {
    // Clean up state on logout
    state = undefined;
    localStorage.removeItem('token');
  }
  return reducers(state, action);
};

// Create the store with the root reducer
const store = configureStore({
  reducer: rootReducer,
});


// Create the persistor
const persistor = persistStore(store);

export { store, persistor };